module.exports = __webpack_public_path__ + "56ac2cf5bd07cf87a85e34e8b02e768e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/fr/area_fr.mp3
 ** module id = 641
 ** module chunks = 0
 **/